import { render, staticRenderFns } from "./DomainDdosMigration.vue?vue&type=template&id=098cedfd"
import script from "./DomainDdosMigration.vue?vue&type=script&lang=js"
export * from "./DomainDdosMigration.vue?vue&type=script&lang=js"
import style0 from "./DomainDdosMigration.vue?vue&type=style&index=0&id=098cedfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports